import { render, staticRenderFns } from "./CustomerGiveaway.vue?vue&type=template&id=07e4274f&"
import script from "./CustomerGiveaway.vue?vue&type=script&lang=js&"
export * from "./CustomerGiveaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports